export function getCurrentPeriod() {
    let currentDate = new Date();
    let firstDayOfWeek = new Date(currentDate);
    firstDayOfWeek.setDate(currentDate.getDate() - currentDate.getDay() + 1);
    let lastDayOfWeek = new Date(currentDate);
    lastDayOfWeek.setDate(currentDate.getDate() - currentDate.getDay() + 7);
  
    let startDate = `${(firstDayOfWeek.getMonth() + 1).toString().padStart(2, '0')}/${firstDayOfWeek.getDate().toString().padStart(2, '0')}/${firstDayOfWeek.getFullYear()}`;
    let endDate = `${(lastDayOfWeek.getMonth() + 1).toString().padStart(2, '0')}/${lastDayOfWeek.getDate().toString().padStart(2, '0')}/${lastDayOfWeek.getFullYear()}`;
  
    return `${startDate}-${endDate}`;
  }
  
  